import { render, staticRenderFns } from "./ButtonMicrosoftLogin.vue?vue&type=template&id=e8de652c&scoped=true"
import script from "./ButtonMicrosoftLogin.vue?vue&type=script&lang=js"
export * from "./ButtonMicrosoftLogin.vue?vue&type=script&lang=js"
import style0 from "./ButtonMicrosoftLogin.vue?vue&type=style&index=0&id=e8de652c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8de652c",
  null
  
)

export default component.exports